import { render, staticRenderFns } from "./ConfiscateMaterial.vue?vue&type=template&id=52c0fe34"
import script from "./ConfiscateMaterial.vue?vue&type=script&lang=js"
export * from "./ConfiscateMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports